import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import registerService from '../../services/registerService';
import Form from '../form/Form';
import SliderAuth from '../utils/SliderAuth'
import './Register.css';

const Register = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('register'); // Estado para controlar pestañas
  const [successMessage, setSuccessMessage] = useState('');

  const initialValues = {
    email: '',
    psw: '',
  };

  const inputsConfig = [
    { label: 'Correo Electrónico', id: 'email', name: 'email', type: 'email', className: 'w-full px-4 py-2 border rounded-md focus:outline-none focus:border-bottom-blue-500', required: true },
    { label: 'Nombre', id: 'name', name: 'name', type: 'text', className: 'w-full px-4 py-2 border rounded-md focus:outline-none focus:border-bottom-blue-500', required: true },
    { label: 'Contraseña', id: 'psw', name: 'psw', type: 'password', className: 'w-full px-4 py-2 border rounded-md focus:outline-none focus:border-blue-500', required: true },
    { label: 'Confirmar Contraseña', id: 'confirmPassword', name: 'confirmPassword', type: 'password', className: 'w-full px-4 py-2 border rounded-md focus:outline-none focus:border-blue-500', required: true },
  ];

  const handleSubmit = async (formData) => {
    const {psw } = formData;
    formData['password'] = psw
    formData= {...formData,'last_name':'test'}
    
    try {
            await registerService.register(formData);
            setSuccessMessage('¡Registro exitoso! Ahora puede iniciar sesión.');
          } catch (err) {
      setError(err.message);

    }
  }

  const handleError = (err) => {
    setError(err);
  };

  return (
    <>
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
          <div className="flex w-[800px] flex-col lg:flex-row">

          <SliderAuth/>
      
            <div className="w-full lg:w-3/5 p-8 mb-3 bg-white shadow-lg rounded-xl mt-3">
              <div className="flex justify-center mb-4">
                <button className="text-blue-500 font-semibold mx-1 border-b-2 border-blue-500 text-sm">
                REGISTRARSE
                </button>
                <Link to="/login" className="text-decoration-none text-gray-500 font-semibold mx-1 text-sm">
                  INGRESAR
                </Link>
              </div>
              {successMessage ? (
                  <div>
                    <p className="mt-6 text-center text-sm text-gray-500">
                    {successMessage}
        <Link to="/login" className="text-decoration-none">
        <a href="#" className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500">
        Iniciar Sesión
        </a>
        </Link>
      </p>
                  </div>
                ) : (
              <Form
                initialValues={initialValues}
                inputsConfig={inputsConfig}
                onSubmit={handleSubmit}
                handleError={handleError}
              />
                )}
              {error && <p className="text-red-500 mt-2">{error}</p>}

            </div>
          </div>
        </div>
    </>

  );

};

export default Register;
